import {Attributes} from 'platform/components';

import {ContractInformationResponseBodyV2} from '@dms/api/customer';

import {TestIdProps} from 'shared/web';

import {useCustomerContractAttributes} from '../../hooks/useCustomerContractAttributes';

interface CustomerContractAttributesProps extends TestIdProps {
  contract: ContractInformationResponseBodyV2;
  displayAftersalesVersion?: boolean;
}

export function CustomerContractAttributes(props: CustomerContractAttributesProps) {
  const [getAttributes] = useCustomerContractAttributes(props.displayAftersalesVersion);
  return (
    <Attributes
      rows={getAttributes(props.contract)}
      size="quarter"
      data-testid={props['data-testid']}
    />
  );
}
